/* 상품 상세 이미지 — 모바일에서 Swiper 로 순환 (지시, 2026-09-10)
 *
 * ⚠️⚠️ **왜 갈아탔나** — 네이티브 스크롤 스냅으로는 이어지는 순환이 안 된다. 끝에서 처음으로
 *    가려면 `scrollLeft` 를 순간이동시켜야 하고 그건 스크롤이 멈춘 뒤(`scrollend`)에만
 *    가능하다. 그 틈에 사용자가 또 밀면 이미 끝이라 **아무 일도 안 난다** — 제보된
 *    "첫 이미지는 나오는데 두 번째로 넘어갈 때까지 딜레이"가 그것이고, 첫 장에서 뒤로
 *    미는 것도 같은 이유로 부드럽지 않았다. Swiper 는 transform + 슬라이드 재배치라 틈이 없다.
 * ⚠️ Swiper 14.1.0 은 `layout/theme.liquid` 에서 **전 페이지에 이미 로드**된다 — 추가 다운로드 0.
 *    ⚠️ 그래서 전역 `Swiper` 가 없으면 **아무 것도 하지 않는다**(네이티브 스크롤이 그대로 남는다).
 *
 * ⚠️⚠️ **모바일(≤749)에서만 켠다.** Dawn 은 `.slider--mobile` 을 그 폭에서만 스크롤시키고,
 *    ≥750 은 `.product__media-item:not(.is-active) { display: none }` 이라 한 장만 보이는
 *    **그리드 + 썸네일**이다. 거기에 Swiper 를 붙이면 썸네일 동기화가 깨진다.
 * ⚠️ Dawn 마크업을 그대로 쓴다(`wrapperClass`·`slideClass`) — 새 DOM 을 만들면 배지·핀치줌·
 *    확대 모달이 붙어 있는 구조를 전부 다시 배선해야 한다.
 * ⚠️ 핀치 줌과 충돌하지 않는다 — `neoteria-pinch-zoom.js` 가 `.product__media` 에서
 *    두 손가락·확대 중 이벤트를 `stopPropagation` 하고, Swiper 의 터치 리스너는 그 **부모**
 *    (wrapper)에 붙으므로 그 제스처는 Swiper 까지 오지 않는다.
 *    ⚠️ Swiper 의 `zoom` 모듈을 켜지 말 것 — 우리 확대는 "손 떼면 원위치"이고 Swiper zoom 은
 *    유지형이라 동작이 다르다(그 규칙은 지시로 정해졌다).
 * ⚠️ Dawn 의 `slider-component` 커스텀 엘리먼트는 `scrollLeft` 기반이라 스크롤이 꺼지면
 *    조용히 잠든다(이벤트가 안 난다) — 끄거나 지우지 않는다(데스크톱에서 그대로 쓴다).
 */
(function () {
  if (window.__ntMediaSwiper) return;
  window.__ntMediaSwiper = true;

  var MQ = '(max-width: 749px)';
  var instances = []; /* [{ el, swiper }] */

  function galleries() {
    var out = [];
    document.querySelectorAll('.product__media-list').forEach(function (ul) {
      var host = ul.closest('slider-component');
      if (!host) return;
      if (host.classList.contains('thumbnail-slider')) return;
      out.push({ host: host, ul: ul });
    });
    return out;
  }

  function slideCount(ul) {
    return ul.querySelectorAll('.product__media-item').length;
  }

  function destroyAll() {
    instances.forEach(function (rec) {
      try {
        rec.swiper.destroy(true, true);
      } catch (e) {}
      rec.el.classList.remove('nt-msw');
    });
    instances = [];
  }

  function build() {
    if (typeof window.Swiper !== 'function') return;

    galleries().forEach(function (g) {
      if (g.host.classList.contains('nt-msw')) return;
      if (slideCount(g.ul) < 2) return; /* 한 장이면 순환할 것이 없다 */

      /* ⚠️ 클래스를 **먼저** 달아야 Swiper 가 측정할 때 이미 스크롤이 꺼진 상태다
         (스냅이 살아 있으면 폭·위치를 잘못 읽는다). */
      g.host.classList.add('nt-msw');

      var sw;
      try {
        sw = new window.Swiper(g.host, {
          wrapperClass: 'product__media-list',
          slideClass: 'product__media-item',
          loop: true,
          slidesPerView: 1,
          spaceBetween: 0, /* 슬라이드 사이 여백 없음(2026-09-28 지시) — CSS gap 도 0 이다(neoteria-media-swiper.css) */
          speed: 320,
          threshold: 8, /* 세로 스크롤 중의 미세한 가로 흔들림을 무시한다 */
          resistanceRatio: 0,
          watchOverflow: true,
          zoom: false,
          /* ⚠️ Dawn 이 이미 라벨·역할을 두었다 — Swiper 가 또 넣으면 중복이 읽힌다. */
          a11y: false,
          /* 변형 교체·필터로 DOM 이 바뀌면 스스로 다시 측정한다. */
          observer: true,
          observeParents: true,
        });
      } catch (e) {
        g.host.classList.remove('nt-msw');
        return;
      }

      wireDots(g, sw);
      instances.push({ el: g.host, swiper: sw });
    });
  }

  /* ── 도트(`.nt-media-dots`) 재배선 ────────────────────────────────
     ⚠️⚠️ **Swiper 로 갈아타면 도트가 죽는다(제보: "bullet pagination 이 작동 안 함").**
        도트는 `snippets/product-media-gallery.liquid` 의 인라인 스크립트가 만들고
        **`scrollLeft` 로** 동작한다 — 클릭은 `slider.scrollTo(...)`, 활성 표시는 `scroll`
        이벤트. 네이티브 스크롤을 끈 순간 **둘 다 아무 일도 하지 않는다.**
     ⚠️ 그래서 **Swiper `pagination` 모듈을 쓰지 않는다.** 그 모듈은 컨테이너에
        `swiper-pagination` 클래스를 붙이는데, 번들 CSS 가 그 클래스에
        `position: absolute` 를 주므로 **슬라이더 밖 형제**인 우리 도트의 자리가 깨진다.
        마크업·CSS 를 건드리지 않는 쪽을 골랐다.
     ⚠️ 버튼을 **복제해 갈아 끼운다** — 옛 `scrollTo` 리스너를 떼는 가장 확실한 방법이고,
        Swiper 가 없을 때는(CDN 실패·데스크톱) 인라인 폴백이 그대로 살아 있어야 한다.
     ⚠️ `slideToLoop`(`slideTo` 아님) — loop 에서는 실제 인덱스와 표시 인덱스가 다르다.
     ⚠️ `realIndex` 로 활성 표시를 갱신한다(loop 보정된 값). */
  function wireDots(g, sw) {
    var box = g.host.parentElement
      ? g.host.parentElement.querySelector('.nt-media-dots')
      : null;
    if (!box) return;

    var olds = box.querySelectorAll('.nt-media-dot');
    if (!olds.length) return;

    var dots = [];
    olds.forEach(function (b, i) {
      var fresh = b.cloneNode(true);
      b.parentNode.replaceChild(fresh, b);
      fresh.addEventListener('click', function () {
        sw.slideToLoop(i);
      });
      dots.push(fresh);
    });

    function paint() {
      var at = sw.realIndex;
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === at);
      }
    }

    sw.on('slideChange', paint);
    /* ⚠️ 손가락으로 끄는 동안에도 따라오게 한다 — `slideChange` 만 걸면 놓는 순간에야 바뀐다. */
    sw.on('realIndexChange', paint);
    paint();
  }

  function apply() {
    if (window.matchMedia(MQ).matches) build();
    else destroyAll();
  }

  function init() {
    apply();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* ⚠️ 이미지가 늦게 크기를 가지면 폭이 바뀐다 — Swiper 는 `observer` 로 잡지만 첫 측정이
     틀린 채 남는 경우가 있어 로드 시점에 한 번 더 갱신한다. */
  window.addEventListener('load', function () {
    apply();
    instances.forEach(function (rec) {
      try {
        rec.swiper.update();
      } catch (e) {}
    });
  });

  /* 변형을 바꾸면 미디어가 다시 그려진다(엘리먼트가 교체되므로 새로 붙여야 한다). */
  document.addEventListener('shopify:section:load', function () {
    destroyAll();
    apply();
  });

  /* ⚠️ 경계를 넘는 신호는 `matchMedia` 의 `change` 가 정확하다 — `resize` 는 중간 폭에서도
     계속 오고, 반대로 **오지 않는 환경도 있다**(폭을 코드로 바꾸는 도구·일부 인앱 브라우저).
     둘 다 걸고 `apply` 가 멱등이라 겹쳐 불려도 안전하다. */
  var mql = window.matchMedia(MQ);
  if (mql.addEventListener) mql.addEventListener('change', apply);
  else if (mql.addListener) mql.addListener(apply);

  var t = 0;
  window.addEventListener('resize', function () {
    clearTimeout(t);
    t = setTimeout(apply, 150);
  });
})();
